import { currencyFormat } from 'common/helpers/numberHelper';

const Duties = (props) => {
  const { duties, settings } = props;
  if (!duties) {
    return null;
  }
  const dutyPaid = duties.filter((duty) => duty.isUnpaidDutyEstimate === false);
  return (
    <>
      {dutyPaid.map((duty) => (
        <div key={duty.id}>
          <div>{duty.title}:</div>
          <div>{currencyFormat(duty.price, settings)}</div>
        </div>
      ))}
    </>
  );
};

export default Duties;
